import { Box, Button, Divider, Typography } from "@mui/material";
import { DaymapDialog, RecordPaging, RecordView } from "daymap-react";
import { useBlocker, useNavigate, useParams, useSearchParams } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { PageContainer } from "../../../../components/layout";
import { RecordModeEnum } from "daymap-react/dist/components/records/RecordActions";
import { useState } from "react";

function Record() {
    const { formId, studentId } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [dirty, setIsDirty] = useState(false);
    const blocker = useBlocker(() => dirty);

    const changeRecord = (rowID: number) => {
        let newParams =  new URLSearchParams(searchParams.toString()); //deep copy so it doesnt update the current page before navigating
        newParams.set('row', rowID.toString());
        if(rowID == 0)
            newParams.set('mode', "2");
        navigate({pathname: `/student/${studentId}/records/${formId}`,search: newParams.toString()})
    }
    const editMode = RecordModeEnum[RecordModeEnum[Number(searchParams.get("mode") ?? 2)] as keyof typeof RecordModeEnum]

    return <PageContainer>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, flexWrap: 'wrap', pb: 2 }}>
            <Button variant="contained" startIcon={<ArrowBackIcon />} onClick={()=> navigate(-1)}>Back</Button>
            {editMode != RecordModeEnum.New && <RecordPaging formId={Number(formId)} studentId={Number(studentId)} rowId={Number(searchParams.get("row"))} onChange={changeRecord} />}
        </Box>
        <DaymapDialog
            open={blocker.state == 'blocked'} 
            title="Are you sure you want to leave this record?" 
        > 
            <Box paddingLeft={3} paddingRight={3}>
                <Typography>You have unsaved changes.</Typography>
                <Typography>Tap Cancel to stay or Leave to discard your changes</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent:'right', gap: 1, flexWrap: 'wrap', pt:3, pb:3}}>
                    <Button onClick={() => {if(blocker.reset) {blocker.reset()}}}>Cancel</Button>
                    <Button variant="contained" onClick={() => {if(blocker.proceed) {blocker.proceed()}}}>Leave</Button>
                </Box>
            </Box>
        </DaymapDialog>
        <Divider />
        <RecordView
            formId={Number(formId)}
            studentId={Number(studentId)}
            rowId={Number(searchParams.get("row"))} 
            editMode={editMode}
            updateRowId={(id: number) => {
                if(id == null) {return;}
                const searchParams = new URLSearchParams(window.location.search);
                searchParams.set('row', id.toString());
                searchParams.set('mode', "0");
                navigate({ pathname: window.location.pathname.replace(/^(\/portal)/,""), search: searchParams.toString() }, { replace: true })
            }}
            back={() =>navigate(-1)}
            add={() => changeRecord(0)}
            setDirty={setIsDirty}
        />
    </PageContainer>
}

export default Record;
